// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import _ from 'underscore';

import trackingService from '../tracking';

type IParamsForTrackingHotelSearch = {
    tourCriteria: any,
    model: any;
    searchFormModel: Backbone.Model,
    startSearchTime: number,
    firstCacheTime: number,
    searchFinishedTime: number,
}

export default (previousTourProducts: Backbone.Collection<Backbone.Model>, params: IParamsForTrackingHotelSearch): void => {
    const {
        tourCriteria,
        model,
        searchFormModel,
        startSearchTime,
        firstCacheTime,
        searchFinishedTime,
    } = params;

    let tourMinPrice: number | undefined;
    const currentDateTours: Backbone.Model[] = model.get('filteredTourProducts');
    const checkInDateRange = searchFormModel.get('checkInDateRange').get('model');
    const flexibleDateSelected = checkInDateRange.get('from').getTime() !== checkInDateRange.get('to').getTime();
    const toursCountForSearchInterval = flexibleDateSelected
        ? previousTourProducts.length
        : (currentDateTours.length || 0);
    const filterCriteria = model.get('filterCriteria');
    const productTypeByFilterCriteria = filterCriteria.get('productType');
    const trackingOptions = {
        tourCriteria,
        toursCountForSearchInterval,
        foundTours: previousTourProducts,
        timestamp: startSearchTime,
        firstCacheTime,
        searchFinishedTime,
        productTypeByFilterCriteria,
    };

    const selectedProductType = 'tourOffer';
    const filteredProducts = model.filterTourProductsByProductTypeWithTourPriority(previousTourProducts, selectedProductType);

    const filteredTourProducts = flexibleDateSelected
        ? filteredProducts.models
        : model.filterTourProductsByDate(filteredProducts.models, filterCriteria.get('selectedTabDate'));

    const minPriceTourProduct = filteredTourProducts.length
        ? _.min(filteredTourProducts, (tourProduct) => tourProduct.get('product').get('priceWithOilTax') ?? tourProduct.get('product').get('price'))
        : null;
    if (minPriceTourProduct) {
        tourMinPrice = minPriceTourProduct.get('product').get('priceWithOilTax')
            || minPriceTourProduct.get('product').get('price') + (minPriceTourProduct.get('product').get('oilTax') || 0);
        Object.assign(trackingOptions, {
            tourMinPrice,
            tourMinPriceId: minPriceTourProduct.get('id'),
            tourMinPriceOilTax: minPriceTourProduct.get('product')?.get('oilTax'),
            tourMinPriceOperatorId: minPriceTourProduct.get('product').get('operator')?.id,
        });
    }

    trackingService.hotelSearchSessions(trackingOptions);
};